import {
  Box,
  Flex,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  SimpleGrid,
  Checkbox,
  IconButton,
  Icon,
  Input,
  FormControl,
  FormLabel,
  Select,
  Stack,
  Button,
  Spinner,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Center,
} from "@chakra-ui/react";
import {
  FaTelegramPlane,
  FaTrash,
  FaUser,
  FaEnvelope,
  FaHome,
  FaEdit,
  FaPhone,
  FaUniversity,
  FaCalendarAlt,
  FaVenusMars,
  FaBook,
  FaTint,
  FaIdCard,
  FaMale,
  FaFemale,
} from "react-icons/fa";
import { useEffect, useState } from "react";
import { BASE_URL } from "../../../Globalapi/Globalapi";

function AdmissionEnquiryTable() {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchField, setSearchField] = useState("name");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // State for editing modal
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedEnquiry, setSelectedEnquiry] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    address: "",
    dob: "",
    gender_id: "",
    class_id: "",
    blood_group_id: "",
    aadhar_no: "",
    father_name: "",
    mother_name: "",
    father_no: "",
    mother_no: "",
  });

  const fetchEnquiries = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASE_URL}/admin/admission/list_all_admission.php`
      );

      const data = await response.json();
      console.log(data);

      if (data.success) {
        setEnquiries(data.data);
      } else {
        setError(data.message || "Failed to load enquiries");
      }
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEnquiries();
  }, []);

  const filteredData = enquiries.filter((entry) =>
    entry[searchField]?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const currentData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handleTransfer = (enquiryId) => {
    console.log(`Transfer admission for enquiry ID: ${enquiryId}`);
    // Add transfer logic here
  };

  const handleEdit = (enquiry) => {
    setSelectedEnquiry(enquiry);
    setFormData({
      name: enquiry.name,
      email: enquiry.email,
      address: enquiry.address || "",
      dob: enquiry.dob || "",
      gender_id: enquiry.gender_id || "",
      class_id: enquiry.class_id || "",
      blood_group_id: enquiry.blood_group_id || "",
      aadhar_no: enquiry.aadhar_no || "",
      father_name: enquiry.father_name || "",
      mother_name: enquiry.mother_name || "",
      father_no: enquiry.father_no || "",
      mother_no: enquiry.mother_no || "",
    });
    setIsEditOpen(true);
  };

  const handleDelete = async (enquiryId) => {
    if (window.confirm("Are you sure you want to delete this enquiry?")) {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/admission/delete_admission.php`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ id: enquiryId }),
          }
        );

        const result = await response.json();
        if (result.success) {
          // Successfully deleted, refresh the enquiry list
          fetchEnquiries();
        } else {
          setError(result.message || "Failed to delete enquiry");
        }
      } catch (err) {
        setError("Failed to delete enquiry");
      }
    }
  };

  const handleSave = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/admin/admission/edit_admission.php`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: selectedEnquiry.id, ...formData }),
        }
      );

      const result = await response.json();
      console.log("edittt", result);

      if (result.success) {
        setIsEditOpen(false); // Close the modal after successful save
        fetchEnquiries(); // Re-fetch data to refresh the table with updated data
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError("Failed to save changes");
    }
  };

  return (
    <Box p={6} maxWidth="100%">
      {/* Existing Layout Code */}
      <Flex
        justify="space-between"
        flexDirection={{ base: "column", md: "row" }}
        className="sb"
        p={3}
        align="center"
      >
        <Box>
          <Flex align="center">
            <Text mr={2}>Rows Per Page</Text>
            <Select
              width="100px"
              value={rowsPerPage}
              onChange={(e) => setRowsPerPage(Number(e.target.value))}
              borderColor="#E9EDF4"
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </Select>
          </Flex>
        </Box>
        <Box>
          <Flex
            align="center"
            mt={{ base: "2", md: "0" }}
            flexDirection={{ base: "column", md: "row" }}
          >
            <Select
              value={searchField}
              onChange={(e) => setSearchField(e.target.value)}
              borderColor="#E9EDF4"
              width={{ base: "100%", md: "150px" }}
            >
              <option value="name">Name</option>
              <option value="email">Email</option>
              <option value="father_name">Father Name</option>
            </Select>
            <Input
              ml={{ base: "0", md: "4" }}
              mt={{ base: "2", md: "0" }}
              type="text"
              placeholder={`Search by ${
                searchField.charAt(0).toUpperCase() +
                searchField.slice(1).replace("_", " ")
              }`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              borderColor="#E9EDF4"
              flexDirection={{ base: "column", md: "row" }}
              width={{ base: "100%", md: "250px" }}
            />
          </Flex>
        </Box>
      </Flex>

      {/* Table Code */}
      <div style={{ overflowX: "auto" }} className="sb">
        {loading ? (
          <Spinner size="xl" />
        ) : error ? (
          <Box>
            <Text color="red.500">{error}</Text>
          </Box>
        ) : currentData.length > 0 ? (
          <Table
            sx={{
              "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
            }}
            overflowX="auto"
          >
            <Thead>
              <Tr>
                <Th>
                  <Checkbox />
                </Th>
                <Th>Name</Th>
                <Th>Email</Th>
                <Th>Phone</Th>
                <Th>Date of Enquiry</Th>
                <Th isNumeric>Class</Th>
                <Th>Status</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentData.map((enquiry) => (
                <Tr key={enquiry.enquiry_id}>
                  <Td>
                    <Checkbox />
                  </Td>
                  <Td>{enquiry.name}</Td>
                  <Td>{enquiry.email}</Td>
                  {/* <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
  {enquiry.father_no || enquiry.mother_no}
</Td> */}
                  <Td>{enquiry.father_no || enquiry.mother_no}</Td>
                  <Td >
                    {new Date(enquiry.created_at).toLocaleDateString()}
                  </Td>
                  <Td isNumeric>{enquiry.class}</Td>
                  <Td>
                    <Badge
                      colorScheme={
                        enquiry.status === "Active" ? "green" : "green"
                      }
                      borderRadius="full"
                      px={4}
                      py={1}
                      fontSize="11px"
                    >
                      {enquiry.status === "Active" ? "Active" : "Active"}
                    </Badge>
                  </Td>
                  <Td>
                    <Box
                      display={{ base: "flex", md: "block" }} // Flex on mobile, block on larger screens
                      alignItems="center"
                    >
                      <IconButton
                        icon={<FaTelegramPlane />}
                        colorScheme="teal"
                        aria-label="Transfer Admission"
                        onClick={() => handleTransfer(enquiry.enquiry_id)}
                        size="sm" // Make the icon smaller
                      />
                      <IconButton
                        marginLeft={3}
                        icon={<FaEdit />}
                        colorScheme="blue"
                        aria-label="Edit Enquiry"
                        onClick={() => handleEdit(enquiry)}
                        mr={2}
                        size="sm" // Make the icon smaller
                      />
                      <IconButton
                        icon={<FaTrash />}
                        colorScheme="red"
                        aria-label="Delete Enquiry"
                        onClick={() => handleDelete(enquiry.id)}
                        size="sm" // Make the icon smaller
                      />
                    </Box>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        ) : (
          <Box>
            <Text>No enquiries found.</Text>
          </Box>
        )}
      </div>

      {/* Pagination Controls */}
      <Flex justify="end" borderTopWidth="1px" className="sb2" p={3}>
        <Button
          onClick={() => setCurrentPage(currentPage - 1)}
          isDisabled={currentPage === 1}
        >
          Prev
        </Button>
        <Stack direction="row" mx={2}>
          {currentPage > 1 && (
            <>
              <Button onClick={() => setCurrentPage(1)}>1</Button>
              {currentPage > 2 && <Text>...</Text>}
            </>
          )}
          <Button backgroundColor="teal" color="white">
            {currentPage}
          </Button>
          {currentPage < totalPages - 1 && (
            <>
              <Text>...</Text>
              <Button onClick={() => setCurrentPage(totalPages)}>
                {totalPages}
              </Button>
            </>
          )}
        </Stack>
        <Button
          onClick={() => setCurrentPage(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Flex>

      {/* Edit Modal */}
      <Modal
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            marginTop={0}
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            <Icon as={FaEdit} boxSize={5} mr={2} />
            Edit Admission Enquiry Form
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": {
                width: "6px", // Thin scrollbar
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)", // Light transparent track
                borderRadius: "10px",
                backdropFilter: "blur(8px)", // Glass effect
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)", // Light blue thumb (frosted)
                borderRadius: "10px",
                backdropFilter: "blur(8px)", // Glass effect
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)", // Slightly darker on hover
              },
            }}
          >
            <Flex direction="column">
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                <FormControl id="name" isRequired>
                  <FormLabel>
                    <Icon as={FaUser} mr={1} color="teal.500" /> Name
                  </FormLabel>{" "}
                  <Input
                    placeholder="Name"
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                    mb={2}
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    _focus={{
                      borderColor: "teal.500",
                      boxShadow: "0 0 0 1px teal.500",
                    }}
                  />
                </FormControl>

                <FormControl id="email" isRequired>
                  <FormLabel>
                    <Icon as={FaEnvelope} mr={1} color="teal.500" /> Email
                  </FormLabel>{" "}
                  <Input
                    placeholder="Email"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    mb={2}
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    _focus={{
                      borderColor: "teal.500",
                      boxShadow: "0 0 0 1px teal.500",
                    }}
                  />
                </FormControl>

                <FormControl id="address" isRequired>
                  <FormLabel>
                    <Icon as={FaHome} mr={1} color="teal.500" /> Address
                  </FormLabel>{" "}
                  <Input
                    placeholder="Address"
                    value={formData.address}
                    onChange={(e) =>
                      setFormData({ ...formData, address: e.target.value })
                    }
                    mb={2}
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    _focus={{
                      borderColor: "teal.500",
                      boxShadow: "0 0 0 1px teal.500",
                    }}
                  />
                </FormControl>

                <FormControl id="dob" isRequired>
                  <FormLabel>
                    <Icon as={FaCalendarAlt} mr={1} color="teal.500" /> Date of
                    Birth
                  </FormLabel>{" "}
                  <Input
                    placeholder="Date of Birth"
                    type="date"
                    value={formData.dob}
                    onChange={(e) =>
                      setFormData({ ...formData, dob: e.target.value })
                    }
                    mb={2}
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    _focus={{
                      borderColor: "teal.500",
                      boxShadow: "0 0 0 1px teal.500",
                    }}
                  />
                </FormControl>

                <FormControl id="gender_id" isRequired>
                  <FormLabel>
                    <Icon as={FaVenusMars} mr={1} color="teal.500" /> Gender
                  </FormLabel>{" "}
                  <Input
                    placeholder="Gender ID"
                    type="number"
                    value={formData.gender_id}
                    onChange={(e) =>
                      setFormData({ ...formData, gender_id: e.target.value })
                    }
                    mb={2}
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    _focus={{
                      borderColor: "teal.500",
                      boxShadow: "0 0 0 1px teal.500",
                    }}
                  />
                </FormControl>

                <FormControl id="class_id" isRequired>
                  <FormLabel>
                    <Icon as={FaBook} mr={1} color="teal.500" /> Class
                  </FormLabel>{" "}
                  <Input
                    placeholder="Class ID"
                    type="number"
                    value={formData.class_id}
                    onChange={(e) =>
                      setFormData({ ...formData, class_id: e.target.value })
                    }
                    mb={2}
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    _focus={{
                      borderColor: "teal.500",
                      boxShadow: "0 0 0 1px teal.500",
                    }}
                  />
                </FormControl>

                <FormControl id="blood_group_id" isRequired>
                  <FormLabel>
                    <Icon as={FaTint} mr={1} color="teal.500" /> Blood Group
                  </FormLabel>{" "}
                  <Input
                    placeholder="Blood Group ID"
                    type="number"
                    value={formData.blood_group_id}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        blood_group_id: e.target.value,
                      })
                    }
                    mb={2}
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    _focus={{
                      borderColor: "teal.500",
                      boxShadow: "0 0 0 1px teal.500",
                    }}
                  />
                </FormControl>

                <FormControl id="aadhar_no" isRequired>
                  <FormLabel>
                    <Icon as={FaIdCard} mr={1} color="teal.500" /> Aadhar Number
                  </FormLabel>{" "}
                  <Input
                    placeholder="Aadhar Number"
                    value={formData.aadhar_no}
                    onChange={(e) =>
                      setFormData({ ...formData, aadhar_no: e.target.value })
                    }
                    mb={2}
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    _focus={{
                      borderColor: "teal.500",
                      boxShadow: "0 0 0 1px teal.500",
                    }}
                  />
                </FormControl>

                <FormControl id="father_name" isRequired>
                  <FormLabel>
                    <Icon as={FaMale} mr={1} color="teal.500" /> Father Name
                  </FormLabel>{" "}
                  <Input
                    placeholder="Father's Name"
                    value={formData.father_name}
                    onChange={(e) =>
                      setFormData({ ...formData, father_name: e.target.value })
                    }
                    mb={2}
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    _focus={{
                      borderColor: "teal.500",
                      boxShadow: "0 0 0 1px teal.500",
                    }}
                  />
                </FormControl>

                <FormControl id="mother_name" isRequired>
                  <FormLabel>
                    <Icon as={FaFemale} mr={1} color="teal.500" /> Mother Name
                  </FormLabel>{" "}
                  <Input
                    placeholder="Mother's Name"
                    value={formData.mother_name}
                    onChange={(e) =>
                      setFormData({ ...formData, mother_name: e.target.value })
                    }
                    mb={2}
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    _focus={{
                      borderColor: "teal.500",
                      boxShadow: "0 0 0 1px teal.500",
                    }}
                  />
                </FormControl>

                <FormControl id="father_no">
                  <FormLabel>
                    <Icon as={FaPhone} mr={1} color="teal.500" /> Father Contact
                    No
                  </FormLabel>{" "}
                  <Input
                    placeholder="Father's Phone Number"
                    value={formData.father_no}
                    onChange={(e) =>
                      setFormData({ ...formData, father_no: e.target.value })
                    }
                    mb={2}
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    _focus={{
                      borderColor: "teal.500",
                      boxShadow: "0 0 0 1px teal.500",
                    }}
                  />
                </FormControl>

                <FormControl id="mother_no">
                  <FormLabel>
                    <Icon as={FaPhone} mr={1} color="teal.500" /> Mother Contact
                    No
                  </FormLabel>{" "}
                  <Input
                    placeholder="Mother's Phone Number"
                    value={formData.mother_no}
                    onChange={(e) =>
                      setFormData({ ...formData, mother_no: e.target.value })
                    }
                    mb={2}
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    _focus={{
                      borderColor: "teal.500",
                      boxShadow: "0 0 0 1px teal.500",
                    }}
                  />
                </FormControl>
              </SimpleGrid>
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              onClick={handleSave}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}

export default AdmissionEnquiryTable;
